import React, { useEffect, useState } from 'react';

import { QuestionAutofillDefaultProps, QuestionAutofillPropTypes } from 'src/components/JobDatasheet/propTypes';
import TextField from 'src/components/TextField';

export const QuestionAutofill = ({
  flash,
  isRectifiedQuestion,
  onChange,
  readonly,
  value,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const [currentValue, setCurrentValue] = useState(value ? value[selectedValueKey] : '');

  useEffect(() => {
    setCurrentValue(value ? value[selectedValueKey] : '');
  }, [value?.value, value?.rectifiedValue]);

  const onInputChange = e => {
    if (!readonly) {
      setCurrentValue(e.target.value);
    }
  };

  const getReturnObject = val => {
    if ( value.type === 'autofill' && value.value === val ) {
      return value;
    }
    
    const returnObject = {
      ...value,
      type: 'text'
    };

    returnObject[selectedValueKey] = val;

    return returnObject;
  };

  return (
    <TextField
      defaultValue={value ? value[selectedValueKey] : ''}
      flash={flash}
      fullsize={'true'}
      onBlur={e => !readonly && onChange(getReturnObject(e.target.value))}
      onChange={onInputChange}
      value={currentValue}
    />
  );
};

QuestionAutofill.propTypes = QuestionAutofillPropTypes;
QuestionAutofill.defaultProps = QuestionAutofillDefaultProps;
